<template>
  <div
    class="vant-table"
    ref="vantTable"
  >
    <div class="content">
      <div class="title">订单选择</div>
      <van-search
        v-model="search.orderNo"
        @search="modalSearch"
        placeholder="请输入订单号"
      />
      <div class="table">
        <div class="table-header">
          <div
            class="th"
            v-for="(item) in option.column"
            :key="item.key"
          >{{ item.title }}</div>
        </div>
        <div class="table-body">
          <div
            class="table-tr"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <van-radio-group
              v-model="radio"
              direction="horizontal"
            >
              <van-radio :name="index"></van-radio>
            </van-radio-group>
            <div
              class="td"
              v-for="(context, i) in option.column"
              :key="i"
            >
              {{ item[context.key] }}
            </div>
          </div>
        </div>
        <van-empty v-if="dataList.length==0" description="暂无数据" />
      </div>
      <van-pagination
        @change="pageChange"
        v-model="formPage.currentPage"
        :total-items="formPage.total"
        :show-page-size="formPage.pageSize"
      >
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
    </div>

    <div class="btn-order">
      <div class="card-btn">
        <van-button
          class="return"
          @click="returnOrderBtn()"
        >取消</van-button>
        <van-button
          class="btn"
          @click="radioChangeConfirm()"
        >确认</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import BScroll from "better-scroll";
import orderApi from "@/request/orderApi";
export default {
  props: {
    params: {
      type: Object,
      default() {
        return {};
      }
    },
    btnStyle: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: false,
      search: {
        orderNo: ""
      },
      radioSelect: 0,
      formPage: {
        pageSize: 10,
        currentPage: 1,
        totalRows: 0
      },
      radio: 0,
      option: {
        column: [
          { title: "订单号", key: "orderNo" },
          { title: "卖家", key: "sellerEnterpriseName" },
          {
            title: "仓库",
            key: "warehouseName",
            render: (h, obj) => {
              let warehouseName = obj.row.orderDetailInfoList[0].warehouseName;
              return h("div", warehouseName);
            },
          },
          {
            title: "产品名称",
            key: "commodityName",
            render: (h, obj) => {
              let commodityName = obj.row.orderDetailInfoList.commodityName;
              return h("div", commodityName);
            },
          },
          {
            title: "订单量",
            key: "quantity",
            align: "center",
            width: "120",
            render: (h, obj) => {
              let quantity = obj.row.orderDetailInfoList.quantity;
              return h("div", quantity);
            },
          },
        ],
      },
      dataList: []
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.vantTable, {
        scrollX: true,
        probeType: 3, // listening scroll hook
      });
    });
    this.getListorder();
  },
  methods: {
    // 查询列表
    getListorder() {
      let params = Object.assign({}, this.params, this.formPage, {
        orderNo: this.search.orderNo,
      }); //;
      delete params.totalRows;
      orderApi.getListOrder(params).then((res) => {
        if (res.returnCode == "0") {
          this.dataList = res.result.dataList;
          this.dataList.forEach(items => {
            items.orderDetailInfoList.forEach(item=> {
               console.log("item", item)
            })
            console.log("items",items)
          })
          console.log("0000", this.dataList)
          this.formPage.pageSize = res.result.pageSize;
          this.formPage.currentPage = res.result.currentPage;
          this.formPage.totalRows = res.result.totalRows;
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },

    pageChange(pageNo) {
      this.formPage.currentPage = pageNo;
      this.getListorder();
    },
    pageSizeChange(pageSize) {
      this.formPage.pageSize = pageSize;
      this.formPage.currentPage = 1;
      this.getListorder();
    },
    modalSearch() {
      this.getListorder();
    },
    radioChangeConfirm() {
      let order = this.dataList[this.radioSelect];
      this.$emit("orderSelect", order);
      this.$emit("showOrder", this.showOrder);
    },
    returnOrderBtn() {
      this.$emit("returnOrderBtn");
    },
  },
};
</script>

<style lang="stylus" scoped>
.vant-table {
  width: 100%;
  white-space: nowrap;
  padding: 20px;
  // overflow: hidden;

  .content {
    // padding: 30px;
    .title {
      font-size: 30px;
      margin-top: 30px;
      text-align: center;
    }
  }

  .content >>> .van-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0.1rem 0.12rem;
    background-color: #fff;
    border: 1px solid #666;
    margin: 20px;
  }

  .content >>> .van-radio--horizontal {
    margin-right: 0;
  }

  .content >>> .van-radio-group--horizontal {
    display: inline-block;
  }

  .table {
    // display: inline-block;
    font-size: 24px;
    overflow-x: auto;
    // padding: 20px;

    .table-header {
      height: 74px;
      line-height: 74px;
      background-color: #F4F4F4;
    }

    .th, .td {
      display: inline-block;
      text-align: center;
      min-width: 120px;
      margin-left: 10px;
    }

    .table-tr {
      height: 74px;
      line-height: 74px;
    }
  }

  .btn-order {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 28px;

    .card-btn {
      width: 100%;
      text-align: right;

      .return {
        height: 50px;
        line-height: 50px;
        margin-right: 40px;
        background: #fff;
        border: 1px solid #e12020;
        color: #e12020;
        border-radius: 20px;
      }

      .btn {
        margin-right: 40px;
        height: 50px;
        line-height: 50px;
        background: #e12020;
        color: #fff;
        border-radius: 20px;
      }

      .van-button__text {
        padding: 40px;
      }
    }
  }
}
</style>